"use client";

import { useTranslations } from "next-intl";
import { buttonVariants } from "@/components/ui/button";
import { useSelectItemEvent } from "@/features/analytics/hooks/use-select-item-event";
import type { DietCatalog, DietCatalogDetail } from "@/features/diets/types";
import {
  getLocaleForPathname,
  getPathname,
  Link,
  type LocalizedRoute,
} from "@/i18n/navigation";
import { objectToQueryString } from "@/lib/utilities";
import { cn } from "@/lib/utils";

export const DietListItemOrderButton = ({
  diet,
  configParams,
  index,
  kcal,
}: {
  diet: DietCatalog | DietCatalogDetail;
  configParams: Record<string, string | number | string[]>;
  index?: number;
  kcal?: string;
}) => {
  const { sendSelectItemEvent } = useSelectItemEvent();
  const t = useTranslations();
  const locale = getLocaleForPathname();

  return (
    <Link
      className={cn(
        buttonVariants({ variant: "secondary" }),
        "h-12 min-h-0 w-full rounded-lg px-0 font-medium md:h-10 md:px-3 xl:h-12",
      )}
      data-pw="configure-diet-button"
      href={
        (getPathname({
          href: {
            pathname: "/configure-diet/[slug]",
            params: { slug: diet.slug },
          },
          locale,
        }) + objectToQueryString(configParams)) as LocalizedRoute
      }
      onClick={() => {
        sendSelectItemEvent({
          diet,
          index,
          kcal,
        });
      }}
      prefetch={true}
    >
      {t("diets.order_diet")}
    </Link>
  );
};
